import React, { useState } from "react";
import Layout from "../../common/Layout";
import AdminSettingsNavigation from "../adminSettings/AdminSettingsNavigation";
import { Tabs, Tab, Box } from "@material-ui/core";
import ProfessionalQualificationsTab from "./ProfessionalQualificationsTab";
import UnitsOfCompetenceTab from "./UnitsOfCompetenceTab";
import AbilitiesKnowledgesTab from "./AbilitiesKnowledgesTab";

const TabPanel = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box p={2}>{children}</Box>}
  </div>
);

const QualificationSkills = (props) => {
  const [activeTab, setActiveTab] = useState(0);


  return (
    <Layout name="Qualification Skills">
      <div className="wizard-container">
        <AdminSettingsNavigation path={props.match.path} />
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-12">
            <Tabs
              value={activeTab}
              onChange={(e, newValue) => setActiveTab(newValue)}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Professional Qualifications" />
              <Tab label="Units of Competence" />
              <Tab label="Abilities & Knowledges" />
            </Tabs>

            <TabPanel value={activeTab} index={0}>
              <ProfessionalQualificationsTab />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
              <UnitsOfCompetenceTab />
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
              <AbilitiesKnowledgesTab />
            </TabPanel>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default QualificationSkills;
